export const devProjects = [
  // {
  //   title: 'Project Name',
  //   description: 'Brief overview of what this project does and the problem it solves.',
  //   tech: ['Tech 1', 'Tech 2', 'Tech 3'],
  //   skills: ['Skill 1', 'Skill 2', 'Skill 3'],
  //   github: 'https://github.com/yourusername/project'
  // }, 
  {
  title: 'Industry Connect',
  description: 'Full-stack professional networking app combining carousel-based matching with AI-powered resume building. Features real-time chat via WebSockets, Auth0 authentication, and OpenAI integration for intelligent CV generation.',
  tech: ['React', 'Node.js', 'Express.js', 'PostgreSQL', 'WebSockets', 'OpenAI API', 'Auth0', 'Material UI'],
  skills: ['Full-stack Development', 'Real-time Communication', 'AI Integration', 'Authentication Systems', 'API Design'],
  github: 'https://github.com/kevincogen/IndustryConnect'
}, 

{
  title: 'LightBnB',
  description: 'Airbnb-style property rental platform with complex PostgreSQL database design. Built relational schema with 4 interconnected tables, wrote optimized SQL queries for search filtering, booking management, and review aggregation.',
  tech: ['PostgreSQL', 'Node.js', 'Express.js', 'JavaScript', 'jQuery', 'SASS'],
  skills: ['Database Design', 'SQL Query Optimization', 'Relational Schema', 'CRUD Operations', 'Backend Architecture'],
  github: 'https://github.com/kevincogen/LightBnB'
},
  // Add more projects by copying the object above
];
